module.exports = __webpack_public_path__ + "img/sld_inverter_red_b1_dark.eeed4eb6.svg";